import {UnitPrices} from '@/helpers/olympiaPrices'

export interface initialStateInterface {
  unitPrices: UnitPrices
  fetchedAt: number | null
  isLoading: boolean
  reexPerDominion: number | null
  dominionFetchedAt: number | null
  isDominionLoading: boolean
  isDominionAttempted: boolean
}

export const initialState: initialStateInterface = {
  unitPrices: {},
  fetchedAt: null,
  isLoading: false,
  reexPerDominion: null,
  dominionFetchedAt: null,
  isDominionLoading: false,
  isDominionAttempted: false,
}
